import type { Bundle, Palette } from './types';

type BundlesProps = { palette: Palette; bundles: Bundle[] };

export function BundlesSection({ palette, bundles }: BundlesProps) {
  return (
    <section id="bundles" className="px-6 pb-16 scroll-mt-24 md:scroll-mt-28 sm:pb-20 lg:px-12">
      <div className="mx-auto max-w-7xl rounded-[32px] border border-slate-200 bg-gradient-to-br from-white to-[#F9F9F7] p-10 shadow-sm">
        <div className="flex flex-col gap-2">
          <p className="text-sm font-semibold uppercase tracking-[0.4em]" style={{ color: palette.forest }}>
            Bundles
          </p>
          <h2 className="text-3xl font-semibold text-slate-900">Start with what your home needs now.</h2>
          <p className="text-base text-slate-700">
            Electrical upgrades are layered after the primary scope. Bundle pricing is available when services are sequenced together.
          </p>
        </div>
        <div className="mt-6 grid gap-4 md:grid-cols-2">
          {bundles.map((bundle) => (
            <div key={bundle.title} className="relative rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
              {bundle.badge ? (
                <span
                  className="absolute right-4 top-4 rounded-full px-3 py-1 text-[0.65rem] font-semibold uppercase tracking-[0.25em]"
                  style={{ backgroundColor: `${palette.sage}33`, color: palette.forest }}
                >
                  {bundle.badge}
                </span>
              ) : null}
              <p className="text-lg font-semibold text-slate-900">{bundle.title}</p>
              <p className="text-sm text-slate-700">{bundle.copy}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
